/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2EmailIcon from 'DesignSystem/Svgs/Tysiav2EmailIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/ExternalProfessionals/Content/ExternalProfessional/ContactInfo/Emails/Email"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let emailEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'email',
path: 'email.address',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Email.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-4PsPS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-2-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2EmailIcon
  viewPath={`${viewPath}/Tysiav2EmailIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 data="email.email.address"
 text={emailEmailAddressValueData}
/>
</div>
{children}
</React.Fragment>)
}